import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import { Flex, Progress, Rating, Table } from '@mantine/core'
import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import { IResponseOptCoordinatorEvaluationWithBudgetRanking } from '@interfaces/api/IDashboard'
import { Money, Num } from '@utils/utils'

const CoordinatorEvaluationWithBudgetRanking = ({ title, data }: { title: string; data: IResponseOptCoordinatorEvaluationWithBudgetRanking }) => {
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Table pos={'relative'}>
        <thead>
          <tr>
            <TableHeaderColumn label={'อันดับ'} width={'0%'} />
            <TableHeaderColumn label={'ผู้ประสานงาน'} width={'10%'} />
            <TableHeaderColumn label={'ค่าเฉลี่ยความพึงพอใจ (จำนวนโครงการ)'} width={'15%'} />
            <TableHeaderColumn label={'จำนวนโครงการ'} width={'10%'} />
            <TableHeaderColumn label={'มูลค่าโครงการ'} width={'10%'} />
            <TableHeaderColumn label={''} width={'40%'} />
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.rank_no}>
              <td>{p.rank_no}</td>
              <td>{p.coordinator_fullname}</td>
              <td>
                {p.avg_project_evaluation_result ? (
                  <Flex gap="xs">
                    {p.avg_project_evaluation_result}
                    <Rating fractions={5} value={parseFloat(p.avg_project_evaluation_result)} readOnly />({p.total_evaluation_projects} โครงการ)
                  </Flex>
                ) : (
                  'ไม่มีข้อมูล'
                )}
              </td>
              <td>{Num(p.total_projects)}</td>
              <td>{Money(p.total_budget)}</td>
              <td>
                <Progress
                  w="100%"
                  size="xl"
                  sections={[
                    {
                      value: parseFloat(p.total_budget) / (parseFloat(data[0].total_budget) / 100),
                      color: 'blue',
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ChartFlexSection>
  )
}

export default CoordinatorEvaluationWithBudgetRanking
